module.exports = __webpack_public_path__ + "img/option-a.3ae768d9.png";